module.exports = __webpack_public_path__ + "static/assets/62a7a936534f1b8c4f0d45ac122272ac.svg";